"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mosaic = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _react = _interopRequireDefault(require("react"));
var _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"];
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
// Row
var StyledMosaicRow = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex: 1;\n\tgrid-gap: 1.563rem;\n\t", ";\n\t", ";\n\t", ";\n\tflex-direction: column;\n\twidth: 100%;\n\tmin-width: 100%;\n\t", "\n"])), _styledSystem.flexbox, _styledSystem.gridGap, _styledSystem.layout, function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.mediaQueries.medium, "{\n        flex-direction : row;\n    }");
});
var MosaicRow = function MosaicRow(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledMosaicRow, props, children);
};

// Column
var StyledMosaicCol = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-direction: column;\n\n\tgrid-gap: 1.563rem;\n\t", ";\n\t", ";\n\t", "\n\t", "\n"])), _styledSystem.flexbox, _styledSystem.gridGap, _styledSystem.layout, function (_ref3) {
  var theme = _ref3.theme,
    flex = _ref3.flex;
  return "".concat(theme.mediaQueries.small, "{\n\t\tflex: ").concat(!flex && '1', ";\n    }");
});
var MosaicCol = function MosaicCol(_ref4) {
  var children = _ref4.children,
    props = _objectWithoutProperties(_ref4, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(StyledMosaicCol, props, children);
};
var MosaicLayout = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tgrid-gap: 1.563rem;\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 100%;\n\tflex-direction: column;\n\t", "\n\t", ";\n\t", ",", " {\n\t\t", ";\n\t}\n\t", ";\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.mediaQueries.large, "{\n        flex-direction : row;\n    }");
}, _styledSystem.gridGap, StyledMosaicCol, StyledMosaicRow, _styledSystem.gridGap, _styledSystem.layout);
var Mosaic = function Mosaic(_ref6) {
  var children = _ref6.children,
    props = _objectWithoutProperties(_ref6, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(MosaicLayout, props, children);
};
exports.Mosaic = Mosaic;
Mosaic.Col = MosaicCol;
Mosaic.Row = MosaicRow;